import { buildReducer, UnifiedGroup, isDeletedGroup, makeHubPersonaId } from '../../../../shared';
import {
    loadUserUnifiedGroupsCompletedAction,
    initGroupsHubWithPrefetchDataAction,
    restoreGroupCompletedAction,
    restorePartiallyRestoredGroupCompletedAction,
    handleSoftDeletedGroupCompletedAction,
} from '../../../../hub';
import { deleteGroupCompletedAction } from '../../../../editors/actions';

//Using ExternalDirectoryObjectId in HubPersonaId as emailaddress of deleted group is not unique.
export default buildReducer<string[]>()
    .handle(deleteGroupCompletedAction, (state, action) => {
        return [makeHubPersonaId(action.payload.groupId || action.payload.mailboxGuid)].concat(
            state
        );
    })
    .handleDataAction(initGroupsHubWithPrefetchDataAction, (state, action) => {
        return updateOwnedGroupIds(action.payload.unifiedGroups);
    })
    .handleDataAction(loadUserUnifiedGroupsCompletedAction, (state, action) => {
        return updateOwnedGroupIds(action.payload.unifiedGroups);
    })
    .handleDataAction(restoreGroupCompletedAction, (state, action) => {
        return updateIdsOnRestoreGroup(state, action.payload.hubPersonaId);
    })
    .handle(restorePartiallyRestoredGroupCompletedAction, (state, action) => {
        return updateIdsOnRestoreGroup(state, action.payload.hubPersonaId);
    })
    .handle(handleSoftDeletedGroupCompletedAction, (state, action) => {
        if (!action.payload.isOwner) {
            return state;
        }

        return [makeHubPersonaId(action.payload.groupId || action.payload.mailboxGuid)].concat(
            state
        );
    })
    .done([]);

function updateIdsOnRestoreGroup(state, payloadGroupId): string[] {
    return state.filter(group => group !== payloadGroupId);
}

function updateOwnedGroupIds(groups: UnifiedGroup[]): string[] {
    if (!groups || groups.length === 0) {
        return [];
    }

    return groups
        ? groups.filter(group => isDeletedGroup(group)).map(group => group.hubPersonaId)
        : [];
}
export type { Action } from '../../../../shared';
